import React from 'react'
import PropTypes from 'prop-types'
import { productPropTypes } from 'Types'
import { path } from 'Utils'
import { Link, BuyButton, Icon, LazyLoadImage, ProductPrice } from 'Blocks'
import { SKIP_IMAGEKIT_STORES } from 'Constants'

function FavouriteCard(props) {
  const { product, removeFavourite } = props
  const { image, title, uuid, slug, brand, flags, store } = product
  const productPagelink = path('product', { uuid, slug })

  return (
    <div className={`favourite instock`}>
      <Link to={productPagelink} className="favourite__imagewrapper">
        <LazyLoadImage
          className="favourite__image"
          alt={title}
          image={image}
          useOriginal={SKIP_IMAGEKIT_STORES.includes(store.name.toLowerCase())}
        />
      </Link>

      <div className="favourite__content">
        <Link className="favourite__link" to={productPagelink}>
          <h2 className="favourite__title">{title}</h2>
        </Link>
        <h3 className="favourite__brand">{brand}</h3>
        <BuyButton {...product} className="favourite__buybtn" />
      </div>

      <ProductPrice
        isDiscounted={flags.isDiscounted}
        className="favourite__price"
        {...product}
      />

      <div className="remove">
        <button
          className="favourite__removebtn"
          onClick={() => removeFavourite(uuid)}
        >
          <Icon name="delete" />
        </button>
      </div>
    </div>
  )
}

FavouriteCard.propTypes = {
  product: PropTypes.shape(productPropTypes),
  removeFavourite: PropTypes.func
}

export default FavouriteCard
